import { Tween, Easing } from '@tweenjs/tween.js';
import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';

class BonusGameDialogueController {
	constructor(vc, conf) {
		this.config = conf;
		this.container = vc;
		if (vc[this.config.item]) {
			this.vc = vc[this.config.item];
			this.vc.BONUS_ROUND_DIALOGUE_TEXT_2.text =
				GameConfigs.bonusRoundInfo?.spins + ' BONUS SPINS';
			this.vc.children[7].bonus_item_3.children[2].text =
				'+' + GameConfigs.config.bonus_progress_half_spins;
			this.vc.children[7].bonus_item_6.children[2].text =
				GameConfigs.config.bonus_progress_end_mult + 'X';
			this.vc.children[7].bonus_item_3.children[2].anchor.x = 0;
			this.vc.children[7].bonus_item_6.children[2].anchor.x = 0;
			if (GameConfigs.config.bonus_progress_half_spins > 9) {
				this.vc.children[7].bonus_item_3.children[2].position.x = 30;
			} else {
				this.vc.children[7].bonus_item_3.children[2].position.x = 43;
			}
			if (GameConfigs.config.bonus_progress_end_mult > 9) {
				this.vc.children[7].bonus_item_6.children[2].position.x = 25;
			} else {
				this.vc.children[7].bonus_item_6.children[2].position.x = 30;
			}
			this.init();
		} else {
			throw new Error(
				'BonusGameDialogueController ' + JSON.stringify(this.config)
			);
		}
	}

	init() {
		this.container.alpha = 0;
		new Tween(this.container)
			.to({ alpha: 1 }, 500)
			.easing(Easing.Back.InOut)
			.start();
		setTimeout(() => {
			window.addEventListener(EVENTS.INTERACTION, this, false);
			if (
				GameConfigs.settings.keyboard_shortcuts &&
				!window.isMobile &&
				!window.isTablet
			) {
				window.addEventListener('keydown', this, false);
			}
		}, 1000);
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.INTERACTION:
				this.handleClick();
				break;
			case 'keydown':
				if (evt.keyCode === 27 || evt.keyCode === 32) {
					this.handleClick();
				}
				break;
			default:
				break;
		}
	}

	handleClick() {
		//TODO GameConfigs.bonusRoundActivated === 'init' need this state or not
		if (GameConfigs.bonusRoundActivated === 'init') {
			if (GameConfigs.modal === 'bonus_game') {
				HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
			}
			GameConfigs.bonusRoundActivated = 'started';
			HELPERS.dispatchCustomEvent(EVENTS.BONUS_ROUND_STATE, {
				state: 'started'
			});
			HELPERS.dispatchCustomEvent(EVENTS.BET_PLACED, { placed: true });
			if (GameConfigs.freeSpinLocal.hasBonus) {
				if (
					GameConfigs.uiComponent &&
					GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]
				) {
					GameConfigs.uiComponent.removeView(
						GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]
					);
				}
			}
			this.removeEvents();
		}
	}

	removeEvents() {
		window.removeEventListener(EVENTS.INTERACTION, this, false);
		window.removeEventListener('keydown', this, false);
	}
}

export default BonusGameDialogueController;
